if (!customElements.get('size-additional-info-popup')) {
class SizeAdditionalInfoPopup extends HTMLElement {
  constructor() {
    super();
    this.sizeInfoInputs = null;
    this.sizeLabels = null;
    this.liveRegion = null;
    this.defaultSizeInfo = '';
    // Bind event handlers
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleLabelMouseEnter = this.handleLabelMouseEnter.bind(this);
    this.handleLabelMouseLeave = this.handleLabelMouseLeave.bind(this);
  }

  connectedCallback() {
    this.sizeInfoInputs = document.querySelectorAll(
      '[data-has-additional-info-input]',
    );
    this.liveRegion = this.querySelector('.size-info-live');
    this.sizeLabels = document.querySelectorAll('[data-has-additional-info]');
    this.initContent();
    this.inputEventManager();
    this.labelsEventManager();
    this.setAttribute('role', 'status');
    this.setAttribute('aria-live', 'polite');
    this.setAttribute('aria-atomic', 'true');
    this.setAttribute('tabindex', '0');
  }

  disconnectedCallback() {
    this.inputEventManager(false);
    this.labelsEventManager(false);
  }

  // Initial content setup
  initContent() {
    if (!this.sizeInfoInputs) {
      console.warn(
        'Size Info Popup: Unable to initialize. No size info inputs found for additional info popup.',
      );
      return null;
    }

    this.sizeInfoInputs.forEach((input) => {
      const isChecked = input.hasAttribute('checked');

      if (isChecked) {
        const heightInfo = input.getAttribute('data-height-additional-info');
        const isHideSizeInfoClass = heightInfo === '' ? 'hidden' : 'show';
        this.classList.add(isHideSizeInfoClass);

        if (heightInfo) {
          this.updateLiveRegion(heightInfo);
          this.defaultSizeInfo = heightInfo;
        }
      }
    });
  }

  labelsEventManager(add = true) {
    if (!this.sizeLabels) {
      console.warn(
        'Size Info Popup: No size labels found for additional info popup.',
      );

      return null;
    }

    this.toggleListeners(
      this.sizeLabels,
      ['mouseenter', 'mouseleave'],
      [this.handleLabelMouseEnter, this.handleLabelMouseLeave],
      add,
    );
  }

  inputEventManager(add = true) {
    if (!this.sizeInfoInputs) {
      console.warn(
        'Size Info Popup: No size info inputs found for additional info popup.',
      );
      return null;
    }

    this.toggleListeners(
      this.sizeInfoInputs,
      ['change'],
      [this.handleInputChange],
      add,
    );
  }

  toggleListeners(nodeList, events, handlers, add = true) {
    nodeList.forEach((node) => {
      events.forEach((event, i) => {
        node[add ? 'addEventListener' : 'removeEventListener'](
          event,
          handlers[i],
        );
      });
    });
  }

  updateSizeInfo(event, setDefault = false) {
    const input = event.target;
    const heightInfo = input.getAttribute('data-height-additional-info');
    if (setDefault) {
      this.defaultSizeInfo = heightInfo;
    }

    this.updateLiveRegion(heightInfo);
  }

  handleInputChange(event) {
    this.updateSizeInfo(event, true);
  }

  handleLabelMouseEnter(event) {
    this.updateSizeInfo(event);
  }

  handleLabelMouseLeave(event) {
    this.updateLiveRegion(this.defaultSizeInfo);
  }

  updateLiveRegion(info) {
    if (this.liveRegion) {
      this.liveRegion.textContent = info;
    }
  }
}

  customElements.define('size-additional-info-popup', SizeAdditionalInfoPopup);
}
